import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    containerId: { type: String, default: "messages-container" }
  }

  connect() {
    this.scrollToBottom()
    this.observeMessages()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  scrollToBottom() {
    setTimeout(() => {
      this.element.scrollTop = this.element.scrollHeight
    }, 100)
  }

  observeMessages() {
    const container = document.getElementById(this.containerIdValue)
    if (!container) return

    this.observer = new MutationObserver((mutations) => {
      let shouldScroll = false

      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          shouldScroll = true
        }
        if (mutation.type === 'characterData') {
          shouldScroll = true
        }
      })

      if (shouldScroll) {
        this.scrollToBottom()
      }
    })

    this.observer.observe(container, {
      childList: true,
      subtree: true,
      characterData: true
    })
  }
}
